import { Empty, Result, Spin } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

interface Props {
    loading: boolean;
    error: boolean;
    empty: boolean;
}

// TODO: no design for this, should be revisited later
export const GraphStateRenderer = ({ loading, error, empty }: Props) => {
    const { t } = usePaldockTranslation("common.errors");

    return (
        <div className={"flex justify-center items-center h-full"}>
            {loading && <Spin size={"large"} />}
            {error && !loading && (
                <Result status={"error"} title={t("something_went_wrong")} subTitle={t("try_again_later")} />
            )}
            {!loading && !error && empty && <Empty />}
        </div>
    );
};
